export default __webpack_public_path__ + "static/media/nft-white.c0b858b1.svg";